<template>
  <div class="personal-detail" ref="personal-detail" v-loading="loading">
    <Nothing v-if="!id" :config="{type:'img_no_data',tip:'点击待办标题查看详情'}"></Nothing>
    <div class="personal-detail-content" v-else-if="!onlyReal">
      <div class="top" ref="top">
        <div class="top-l">
          <el-checkbox class="list-checkbox" @change="taskStatusChange" v-model="status"></el-checkbox>
          <SelectTime v-model="dataset.due_date" @change="timeChange" :disabled="onlyReal"></SelectTime>
          <SelectColor v-model="dataset.colorMark" @change="colorChange" :disabled="onlyReal">
            <div class="color-show">
              <p v-if="dataset.color_mark && dataset.color_mark.id">
                <span class="select-round" :style="{'background':dataset.color_mark.color_number}"></span>
                <span>{{dataset.color_mark.color_name}}</span>
              </p>
              <p v-else>
                <i class="icon iconfont iconicon_sign"></i>
                <span>添加标记</span>
              </p>
            </div>
          </SelectColor>
        </div>
        <el-dropdown size="small" trigger="click" class="personal-popover" placement="bottom" :show-timeout="100">
          <i class="icon iconfont iconicon_more_task1 tableIconHover"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="del" v-if="dataset.delete_permission && !onlyReal" @click.native="delTodo">
              <i class="icon iconfont iconicon_recycle_bin"></i>删除
            </el-dropdown-item>
            <el-dropdown-item v-if="dataset.completion_date" class="no-hover" :class="{'not-border':!dataset.completion_date}">
              <div class="complete-time">
                <span>{{dataset.completion_date ? getDayType(dataset.completion_date) : ''}} 完成</span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="title" ref="title">
        <div v-if="isTitleEdit" class="title-input">
          <el-input maxlength="180" type="textarea" ref="inputs" autosize v-model="editValue" placeholder="请输入标题" @blur="cancelBtn"></el-input>
        </div>
        <span v-else @click="editTitle">{{dataset.title}}</span>
      </div>
      <div class="edit-box" ref="edit-box">
        <WangEditor v-if="show" @click.native.stop ref="WangEditor" :height="height" :textInfo="dataset.description || null" @editorCancel="show = false" :isTaskDetail="true" :showBtn="false" @blur="editorSubmit"></WangEditor>
        <div class="fu-edit" @click="show = true" v-else>
          <div class="fu-tip" v-if="isNull">点击添加待办描述</div>
          <div class="fu-test" v-else v-html="htmlValue"></div>
        </div>
      </div>
    </div>
    <div v-else class="personal-detail-content only-real">
      <div class="top">
        <div class="top-l">
          <!-- <toolTip style="width:100%;" maxWidth="100%" :title="dataset.title">
            {{dataset.title}} -->
          <span class="title">{{dataset.title}}</span>
          <!-- </toolTip> -->
        </div>
        <div class="complete-time" v-if="dataset.due_date || dataset.completion_date">
          <span v-if="dataset.due_date">{{dataset.due_date.replace(/-/g,'/')}} 截止</span>
          <span v-if="dataset.completion_date">{{dataset.completion_date ? getDayType(dataset.completion_date) : ''}} 完成</span>
          <div v-if="dataset.color_mark">
            <span class="select-round" v-if="dataset.color_mark" :style="{'background':dataset.color_mark.color_number}" style="margin-right: 4px;"></span>
            <span>{{dataset.color_mark.color_name}}</span>
          </div>
        </div>
      </div>
      <div class="text-box">
        <div class="not-box" v-if="isNull">暂无描述</div>
        <div class="text-content" v-html="htmlValue" v-else></div>
      </div>
    </div>
  </div>
</template>
<script>
import WangEditor from '@/components/wangEditor'
import { createEditor } from '@wangeditor/editor'
import Nothing from '@/components/nothing'
import api from '@/services/api/mine/mine'
import SelectColor from './selectColor'
import SelectTime from './selectTime'
import elementResizeDetectorMaker from 'element-resize-detector'
import dayjs from "dayjs";
export default {
  props: ['id', 'onlyReal'],
  components: {
    Nothing,
    SelectColor,
    SelectTime,
    WangEditor
  },
  watch: {
    async id(val) {
      this.isNull = true
      this.htmlValue = ''
      this.dataset.description = ''
      this.textValue = ''
      this.show = false
      if (val) {
        this.$nextTick(() => {
          if (!this.$refs.title || this.erd) return
          this.erd = elementResizeDetectorMaker();
          this.erd.listenTo(this.$refs.title, async (ele) => {
            let topEle = this.$refs.top.offsetHeight
            let titleEle = this.$refs.title.offsetHeight
            let height = this.$refs['personal-detail'].offsetHeight
            this.height = height - topEle - titleEle - 100 + 'px'
          })
        })
        this.init()
      } else {
        this.erd.removeAllListeners(this.$refs.title)
        this.dataset = {}
      }
    },
    dataset: {
      handler() {
        if (this.dataset.description) {
          this.htmlValue = createEditor({ content: JSON.parse(this.dataset.description) }).getHtml()
          this.textValue = createEditor({ content: JSON.parse(this.dataset.description) }).getText().replace(/\ +/g, '').replace(/[ ]/g, '').replace(/[\r\n]/g, '') // 去除空格回车换行
          const _text = this.textValue.replace(/\s+/g, "").replace(/&nbsp+/g, "")
          if (this.htmlValue.indexOf('<img') < 0 && !_text) {
            this.isNull = true
          } else {
            this.isNull = false
          }
          console.log(this.isNull)
        } else {
          this.htmlValue = ''
          this.dataset.description = ''
          this.textValue = ''
          this.show = false
        }
      },
      deep: true
    },
  },
  data() {
    return {
      dataset: {},
      status: false,
      textValue: '',
      htmlValue: '',
      show: false,
      height: '400px',
      isChange: false,
      erd: '',
      loading: false,
      isTitleEdit: false,
      editValue: '',
      isNull: true
    }
  },
  beforeDestroy() {
    this.erd ? this.erd.removeAllListeners(this.$refs.title) : ''
  },
  mounted() {
    this.id ? this.init() : ''
  },
  methods: {
    getDayType(time) {
      return dayjs(time).format("YYYY/MM/DD HH:mm")
    },
    async init() {
      this.isTitleEdit = false
      this.loading = true
      let result = await api.todoDetail({ id: this.id })
      this.dataset = JSON.parse(JSON.stringify(result))
      this.status = this.dataset.status === 1 ? false : true
      this.dataset.colorMark = this.dataset.color_mark ? this.dataset.color_mark.id : ''
      this.loading = false
    },
    async delTodo() {
      await this.$wfAlert('warning', `确定删除该待办？`)
      await api.deleteTodo({ id: this.dataset.id })
      this.$emit('delSuccess', { id: this.dataset.id, isCompete: this.status })
    },
    taskStatusChange() {
      let d = this.status ? 2 : 1
      this.dataset.status = d
      this.$emit('taskStatusChange', JSON.parse(JSON.stringify(this.dataset)))
    },
    colorChange(item) {
      this.dataset.color_mark = item
      this.$emit('colorChange', JSON.parse(JSON.stringify(this.dataset)))
    },
    timeChange() {
      this.$emit('timeChange', JSON.parse(JSON.stringify(this.dataset)))
    },
    editorSubmit(html, val, text) {
      // console.log('------asdasd--------', html)
      // const _text = text.replace(/\s+/g, "").replace(/&nbsp+/g, "")
      // if (val.indexOf('<img') < 0 && !_text) {
      //   this.show = false
      //   return
      // }
      this.show = false
      this.isChange = false
      this.dataset.description = html
      api.todoUpdate({ id: this.dataset.id, description: html })
    },
    editTitle() {
      this.isTitleEdit = true
      this.editValue = this.dataset.title
      this.$nextTick(() => {
        this.$refs['inputs'].focus()
      })
    },
    cancelBtn() {
      if (this.editValue === this.dataset.title) {
        this.isTitleEdit = false
        return
      } else if (this.editValue === '') {
        this.$message.warning('请输入标题')
        // this.isTitleEdit = false
        this.$refs['inputs'].focus()
        return
      } else {
        this.changeTitle()
      }
    },
    changeTitle() {
      this.dataset.title = this.editValue
      this.cancelBtn()
      this.$emit('titleChange', JSON.parse(JSON.stringify(this.dataset)))
    }
  }
}
</script>
<style lang="scss" scoped>
.personal-detail {
  height: calc(100% - 8px);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  border-radius: 4px;
  .title-input {
    width: 100%;
    /deep/ {
      .el-textarea__inner {
        font-size: 18px !important;
        padding: 0 !important;
        border: 0 none !important;
        color: initial;
        line-height: 22px;
        word-break: break-all;
        font-weight: bold;
      }
    }
  }
  .complete-time {
    display: flex;
    align-items: center;
    gap: 26px;
    span {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
    }
  }
  /deep/ {
    .fu-test {
      line-height: 1.6;
      img {
        max-width: 100%;
      }
    }
    ul li {
      list-style: disc;
    }
    ol li {
      list-style: decimal;
    }
    // ul,
    // ol {
    //   padding-left: 18px;
    // }
    .editor-wrap {
      border-top: 1px solid rgba(231, 232, 237, 0.6);
      height: 99%;
    }
    .editor-wrap .editor-con {
      border: 0 none;
      // border-bottom: 1px solid rgba(231, 232, 237, 0.6);
      display: flex;
      flex-direction: column;
      height: 100%;
      > div:first-child {
        border: 0 none !important;
      }
      div[data-w-e-textarea]{
        flex: 1;
        height: auto !important;
      }
    }
    .personal-popover {
      i {
        font-size: 15px;
        padding: 4px;
        border-radius: 4px;
        margin-left: 16px;
      }
      .no-hover {
        border-top: 1px solid rgba(32, 32, 32, 0.08);
        padding: 0 !important;
        margin: 0 15px;
        box-sizing: border-box;
        cursor: auto;
        color: rgba(32, 32, 32, 0.6);
        font-size: 12px;
      }
      .not-border {
        border: 0 none;
      }
    }
    .btn-box {
      color: rgba(32, 32, 32, 0.8);
    }
  }
  .personal-detail-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .title {
    font-size: 18px;
    color: initial;
    display: flex;
    align-items: center;
    // min-height: 64px;
    padding: 24px 0;
    > span {
      line-height: 22px;
      word-break: break-all;
      font-weight: bold;
    }
  }
  .edit-box {
    flex: 1;
    height: 0;
    overflow-x: hidden;
    /deep/{
      .w-e-text-container [data-slate-editor]{
        padding:0 !important;
      }
    }
  }
  .fu-tip {
    font-size: 14px;
    color: rgba(13, 31, 60, 0.4);
  }
  .fu-edit {
    cursor: pointer;
  }
  .top {
    height: 75px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(231, 232, 237, 0.6);
    background-color: #fff;
    flex-shrink: 0;
    box-sizing: border-box;
    padding-top: 16px;
    .iconicon_delete {
      cursor: pointer;
    }
    .list-checkbox {
      margin-right: 24px;
    }
    .top-l {
      display: flex;
      align-items: center;
    }
  }
  .select-round {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
    // margin-right: 24px;
  }
  .only-real {
    .title {
      height: auto;
    }
    .top {
      flex-direction: column;
      padding-bottom: 16px;
      align-items: flex-start;
      height: auto;
      padding-bottom: 12px;
      // .select-round {
      //   position: absolute;
      //   top: 29px;
      //   left: -28px;
      //   margin: 0;
      // }
    }
    .top .top-l {
      width: 100%;
      box-sizing: border-box;
      padding-top: 24px;
    }
    .top .top-l .title {
      padding: 0;
      font-weight: bold;
    }
    .complete-time {
      padding-top: 12px;
      span:last-child {
        margin: 0;
      }
    }
  }
  .text-box {
    padding: 16px 0;
  }
  .not-box {
    font-size: 14px;
    color: rgba(13, 31, 60, 0.4);
  }
}
</style>
